import { createAsyncThunk } from "@reduxjs/toolkit";

import coreAPIs from "../../../services/api/core";

export const getSubtitlesTemplates = createAsyncThunk("core/subtitleTemplates/get", async (payload) => {
  try {
    const response = await coreAPIs.getSubtitlesTemplates(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const createSubtitlesTemplate = createAsyncThunk("core/subtitleTemplates/create", async (payload) => {
  try {
    const response = await coreAPIs.createSubtitlesTemplate(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getSubtitlesTemplateById = createAsyncThunk("core/subtitleTemplates/getById", async (payload) => {
  try {
    const response = await coreAPIs.getSubtitlesTemplateById(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const updateSubtitlesTemplateById = createAsyncThunk("core/subtitleTemplates/updateById", async (payload) => {
  try {
    const response = await coreAPIs.updateSubtitlesTemplate(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const deleteSubtitlesTemplateById = createAsyncThunk("core/subtitleTemplates/deleteById", async (payload) => {
  try {
    const response = await coreAPIs.deleteSubtitlesTemplate(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getSubtitlesTemplateByClipId = createAsyncThunk("core/subtitleTemplates/getByClipId", async (payload) => {
  try {
    const response = await coreAPIs.getSubtitlesTemplateByClipId(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const generateSubtitleTranscripts = createAsyncThunk(
  "core/subtitleTemplates/generateTranscript",
  async (payload) => {
    try {
      const response = await coreAPIs.generateSubtitleTranscripts(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const burnSubtitles = createAsyncThunk("core/subtitleTemplates/burn", async (payload) => {
  try {
    const response = await coreAPIs.burnSubtitles(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getVariantSubtitleTemplates = createAsyncThunk("core/subtitleTemplates/getVariant", async (payload) => {
  try {
    const response = await coreAPIs.getVariantSubtitleTemplates(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getSubtitleFonts = createAsyncThunk("core/subtitleTemplates/getFonts", async (payload) => {
  try {
    const response = await coreAPIs.getSubtitleFonts(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const subtitleFontSupported = createAsyncThunk("core/subtitleTemplates/fontSupported", async (payload) => {
  try {
    const response = await coreAPIs.subtitleFontSupported(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
